// https://www.figma.com/file/q7KlcLyYFswO2QB3I4BWmE/Interests-Graph-on-Web?node-id=4%3A2496
import { useContext } from 'react'
import { css, useTheme } from '@fable/theme'
import {
  Loader,
  PaginationContainer,
  PaginationContainerContext,
} from '@fable/components'
import { Club } from '@fable/types'
import { useErrorModal, useTypedSelector } from 'hooks'
import ProfileClubsEmptyState from './ProfileClubsEmptyState'
import ClubsList from 'components/clubs_list/ClubsList'

const ProfileClubsList = ({ profileUserId }: { profileUserId?: string }) => {
  const { query, list, error } = useContext(PaginationContainerContext)
  const { profile } = useTypedSelector(({ user }) => user)
  const { mediaQueries } = useTheme()

  // filter if viewer is not the logged in user
  const clubs: Club[] = (list || []).filter((x: Club) =>
    profile.data?.id !== profileUserId ? x.access_type === 'open' : x
  )

  useErrorModal(error)

  return query.isFetched && !clubs.length ? (
    <ProfileClubsEmptyState />
  ) : (
    <div
      className={css`
        margin: 0 auto;
        max-width: 328px;
        ${mediaQueries.mobileS} {
          max-width: 332px;
        }
        ${mediaQueries.tablet} {
          max-width: 432px;
        }
      `}
    >
      <ClubsList clubs={list} />
    </div>
  )
}

const ProfileClubs = ({ profileUserId }: { profileUserId?: string }) =>
  profileUserId ? (
    <PaginationContainer
      queryArgs={['clubs', profileUserId]}
      endpoint={`/users/${profileUserId}/clubs`}
      limit={20}
      scrollLevel="fullPage"
    >
      <ProfileClubsList />
    </PaginationContainer>
  ) : (
    <Loader />
  )

export default ProfileClubs
